<template>
    <router-view></router-view>
</template>
<script>
export default {
  name: "usercontainer",
};
</script>

<style lang="less" scoped>
</style>
